import ReactOnRails from 'react-on-rails';

import BranchFilter from '@javascript/branches/branchFilter';
import BranchFilterModal from '@javascript/branches/branchFilterModal';
import BranchResults from '@javascript/branches/branchResults';
import BranchReviews from '@javascript/branches/branchReviews';
import FeedbackContainer from '@components/feedback/feedbackContainer';
import GalleryTrigger from '@components/application/galleryTrigger';
import LazyLoader from '@components/helpers/lazyLoader';
import LocationInput from '@components/application/input/locationFinder/locationInput';
import OpenHoursContainer from '@javascript/branches/openHoursContainer';
import Pagination from '@components/application/pagination/index';

// Shared components
import AccountListener from '@components/account/accountListener';
import FinanceLightboxWithModal from '@components/finance/financeLightboxWithModal';
import GalleryWrapper from '@components/gallery/galleryWrapper';
import Toast from '@components/application/toast';

ReactOnRails.register({
  BranchFilter,
  BranchFilterModal,
  BranchResults,
  BranchReviews,
  FeedbackContainer,
  GalleryTrigger,
  LazyLoader,
  LocationInput,
  OpenHoursContainer,
  Pagination,
  // Shared components
  AccountListener,
  FinanceLightboxWithModal,
  GalleryWrapper,
  Toast,
});
